export default __webpack_public_path__ + "static/media/1.8e84dfb2.png";